import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bestellsite',
  templateUrl: './bestellsite.component.html',
  styleUrls: ['./bestellsite.component.css']
})
export class BestellsiteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
